@if (type === 'tag' && selectedBanner && selectedQuote) {
<!-- Exclusive tariff tags -->
<div class="d-inline-flex ms-3 px-2 py-25 rounded-top" [ngStyle]="selectedBanner?.scriptSource"
  (click)="handlePopupClick($event)">
  @if (selectedBanner?.icons?.prefix){
  <img class="me-2 banner-img" [src]="selectedBanner?.icons?.prefix" alt="icon" />
  }

  <span class="fs-17 fw400 lh-1" [innerHTML]="bannerTemplate"></span>
</div>
}

@if (type === 'infoBar' && selectedBanner && selectedQuote) {
<!-- Info bar -->
<div class="p-2 rounded-1 fw700" [ngStyle]="selectedBanner?.scriptSource">
  @if (selectedBanner?.icons?.prefix){
  <img class="me-2 banner-img" [src]="selectedBanner?.icons?.prefix" alt="icon" />
  }
  {{ selectedBanner?.content }}
</div>
}

<!-- Tool tip -->
@if (type === 'toolTip' && selectedBanner && selectedQuote) {
<div [ngStyle]="selectedBanner?.scriptSource">
  {{ selectedBanner?.content }}
</div>
}

<!-- App related info -->
@if (type === 'appInfo' && selectedBanner && selectedQuote) {
<div class="my-3 px-2 py-25 rounded d-flex align-items-center" [ngStyle]="selectedBanner?.scriptSource"
  (click)="handlePopupClick($event)">
  @if (selectedBanner?.icons?.prefix){
  <img class="me-2 banner-img" [src]="selectedBanner?.icons?.prefix" alt="icon" />
  }

  <span class="fs-17 fw400 lh-1" [innerHTML]="bannerTemplate"></span>
</div>
}

<!-- CTM and Supplier Rewards -->
@if ((type === 'ctmRewards' || type === 'supplierRewards') && selectedBanner && selectedQuote) {
<div class="p-2 rounded-1 d-flex gap-2" [ngStyle]="selectedBanner?.scriptSource">
  @if (selectedBanner?.icons?.prefix){
  <img class="w22px object-fit-contain" [src]="selectedBanner?.icons?.prefix" alt="icon" />
  }
  <p class="m-0 fs-17 lh-1">
    <span [innerHTML]="selectedBanner?.content"></span>
    @if (selectedBanner?.popup?.text === 'Find out more') {
    <button [id]="'EnergyComparison_YourTariffs_TariffsYouCanSwitch_FindOutMore'"
      class="btn btn-secondary-link fs-17 mb-0 ps-0" (click)="openMessage('findOutMore', 'findOutMore')">
      Find out more
    </button>
    }
  </p>
</div>
}